// extracted by mini-css-extract-plugin
module.exports = {"link":"EmailRelatedCard_link__10L13","subject":"EmailRelatedCard_subject__26J8o","body":"EmailRelatedCard_body__2YJTf"};